import { render } from "./DeliveryAddress.vue?vue&type=template&id=6efdac3a"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__